module.exports = "/packs/media/images/GroupedMocks-d5c6ed9c5f66ba8438105473cf3e0932.png";